import request from '@/router/axios'
const baseUrl = 'http://47.92.102.238:8080'
const baseExamRecordUrl = 'http://47.92.102.238:8080/exercise/v1/examRecord/'
// const baseUrl = 'http://api.exam.chineseall.cn:8081'
// const baseExamRecordUrl = 'http://api.exam.chineseall.cn:8081/exercise/v1/examRecord/'

export function fetchList(query,userid) {
  return request({
    url: baseExamRecordUrl + 'userRecords/'+userid,
    method: 'get',
    params: query
  })
}


export function getObj(id, query) {
  return request({
    url: baseExamRecordUrl + id,
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: baseExamRecordUrl,
    method: 'post',
    data: obj
  })
}


export function start(examId) {
  return request({
    url: baseUrl+`/exercise/v1/subjects/startExam/${examId}`,
    method: 'get',
  })
}


//提交答案
export function submitExam(examId, examRecordId, duration, answers) {
  return request({
    url: baseUrl+`/exercise/h5/answer/submitAll`,
    method: 'post',
    data: { examId:examId, examRecordId:examRecordId, duration:duration, answers:answers }
  })
}


// export function start(examId) {
//   return request({
//     url: baseExamRecordUrl + 'start',
//     method: 'post',
//     headers: {
//       "Content-Type": "application/json",
//     },
//     data: obj
//   })
// }

export function anonymousUserStart(obj) {
  return request({
    url: baseExamRecordUrl + 'anonymousUser/start',
    method: 'post',
    params: obj
  })
}




export function getCurrentTime() {
  return request({
    url: baseExamRecordUrl + 'currentTime',
    method: 'get'
  })
}

// 查询成绩详情
export function examRecordDetails(id) {
  return request({
    url: baseExamRecordUrl + id + '/details',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/exam/examRecord.js